export module GameInfo {
    export enum States {
        BET_START = 0,
        DRAWING = 5,
        WINNING_PLAN = 7,
        DRAWING_HISTORY = 6,
    }
}
export interface GameInfo {
    State: GameInfo.States;
    Timestamp: string;
    BetAcceptanceTime: number;
    LastResults: {
        BingoGameID: number;
        GameDate: string;
        Drawn: string;
        Extra: string;
    } [],
    WinPlan: {
        DrawSize: number;
        NumberSize: number;
        PickSize: number;
        WinningTable: {
            1: number;
            2: number;
            3: number;
            4: number;
            5: number;
            6: number;
            7: number;
            8: number;
            9: number;
            10: number;
        }[];
    }
    Game: {
        BingoGameID: number;
        Calculated: boolean;
        GameDate: string;
        Drawn: string;
        Extra: string;
    }
}


// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/domain/signals/game-info.ts